// extracted by mini-css-extract-plugin
export default {"login":"jb_nPKaQ","_hidden":"Oxk0kLZa","desktop":"desktop","mobile":"mobile"};